import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/adobe': {
    width: 460,
    height: 512,
    paths: [
      {
        d: 'M289.9 64.3h170.9v384zM170.9 64.3l-170.9 384v-384h170.9zM230.4 206.4l107.5 241.9h-73l-30.7-76.8h-78.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/adobe.js
// module id = null
// module chunks = 